let store = require("../store");
let actions = require("../actions");

class TokenGenerator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: ""
    };
  }

  componentDidMount() {
    let { studyId, subjectId } = this.props;

    this.interval = setInterval(() => {
      let alpha = Math.random().toString(36).match(/[a-z]/g).join("");

      this.setState({
        token: new Array(5).join(alpha).match(/\w{4}/g).slice(0, 4).join(" ")
      });
    }, 50);

    actions.createSubjectToken(studyId, subjectId).then((payload) => {
      let token = payload.token.match(/\w{4}/g).join(" ");

      setTimeout(() => {
        this.setState({ token });

        clearInterval(this.interval);
      }, 500);
    }).catch((err) => {
      clearInterval(this.interval);

      this.setState({ token: "[error]" });
    });
  }

  render() {
    return (
      <div className="rc-subject-view-token">
        <p>{tx("link_key_note")}:</p>
        <div>{this.state.token}</div>
      </div>
    );
  }
}

module.exports = TokenGenerator;